import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const donationConfigurationFields: FieldInterface[] = [
  {
    key: 'donationTypes',
    originKey: 'donation_types',
    type: FIELD_TYPES.object,
    objectType: 'LabelValueType',
    objectTypePath: 'src/tpbp-core/models/common.const',
    isMultiple: true,
  },
  {
    key: 'natures',
    originKey: 'natures',
    type: FIELD_TYPES.object,
    objectType: 'LabelValueType',
    objectTypePath: 'src/tpbp-core/models/common.const',
    isMultiple: true,
  },
  {
    key: 'donationModes',
    originKey: 'donation_modes',
    type: FIELD_TYPES.object,
    objectType: 'LabelValueType',
    objectTypePath: 'src/tpbp-core/models/common.const',
    isMultiple: true,
  },
]

const donationConfigurationRelations: RelationInterface[] = [
  {
    key: '_donees',
    originKey: 'donees',
    objectType: OBJECT_TYPES.doneesConfiguration,
  },
]

export { donationConfigurationFields, donationConfigurationRelations }
